const parseCategories = categories => ({
  templates: categories.filter((category) => {
    const templateSlugs = [
      'after-effects-templates',
      'premiere-pro-templates',
      'motion-graphics-templates',
      'premiere-rush-templates',
      'davinci-resolve-templates',
      'final-cut-pro-templates',
    ];

    return templateSlugs.includes(category.slug);
  }),

  presets: categories.filter((category) => {
    const presetSlugs = [
      'after-effects-presets',
      'premiere-pro-presets',
      'davinci-resolve-macros',
    ];

    return presetSlugs.includes(category.slug);
  }),

  audio: categories.filter((category) => {
    const audioSlugs = [
      'royalty-free-music',
      'sound-effects',
    ];

    return audioSlugs.includes(category.slug);
  }),

  videos: categories.filter((category) => {
    const videoSlugs = [
      'stock-video',
      'stock-motion-graphics',
    ];

    return videoSlugs.includes(category.slug);
  }),

  images: categories.filter((category) => {
    const imageSlugs = [
      'stock-photos',
      'graphics',
    ];

    return imageSlugs.includes(category.slug);
  }).sort((a, b) => {
    if (a.name > b.name) {
      return 1;
    } if (a.name < b.name) {
      return -1;
    }
    return 0;
  }),
});
export default parseCategories;

export const getAssetType = (categoryType, categorySlug) => {
  if (categorySlug === 'royalty-free-music') {
    return 'song';
  } if (categorySlug === 'sound-effects') {
    return 'sfx';
  } if (categorySlug === 'stock-photos') {
    return 'photo';
  } if (categorySlug === 'graphics') {
    return 'graphics';
  }
  const lowercaseSingularCategoryType = categoryType.toLowerCase().replace(/s$/g, '');
  return lowercaseSingularCategoryType;
};

export const getAssetTypeFromCategorySlug = (categorySlug) => {
  const parsedCategories = parseCategories([{
    slug: categorySlug,
  }]);
  const categoryType = Object.keys(parsedCategories).filter(key => parsedCategories[key].length > 0)[0];
  return getAssetType(categoryType, categorySlug);
};
